// Google Analytics event tracking utility

/**
 * Track Google Analytics event
 * @param {string} eventName - Event name (e.g., 'add_to_cart', 'search', 'begin_checkout', 'purchase')
 * @param {object} params - Event parameters
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, params);
  }
}

/**
 * Track add to cart event
 * @param {object} product - Product object with id, name, price, etc.
 * @param {number} quantity - Quantity added
 */
export function trackAddToCart(product, quantity = 1) {
  trackEvent("add_to_cart", {
    currency: "EGP",
    value: (product.price || 0) * quantity,
    items: [
      {
        item_id: String(product.id),
        item_name: product.name || product.title || "",
        price: product.price || 0,
        quantity: quantity,
      },
    ],
  });
}

/**
 * Track search event
 * @param {string} searchQuery - Search query string
 */
export function trackSearch(searchQuery) {
  trackEvent("search", {
    search_term: searchQuery,
  });
}

/**
 * Track begin checkout event
 * @param {Array} items - Cart items
 * @param {number} value - Total cart value
 */
export function trackBeginCheckout(items, value) {
  trackEvent("begin_checkout", {
    currency: "EGP",
    value: value,
    items: items.map((item) => ({
      item_id: String(item.id),
      item_name: item.name || "",
      price: item.price || 0,
      quantity: item.qty || 1,
    })),
  });
}

/**
 * Track purchase event
 * @param {string} transactionId - Order ID or transaction ID
 * @param {Array} items - Purchased items
 * @param {number} value - Total purchase value
 * @param {string} currency - Currency code (default: EGP)
 */
export function trackPurchase(transactionId, items, value, currency = "EGP") {
  trackEvent("purchase", {
    transaction_id: String(transactionId),
    value: value,
    currency: currency,
    items: items.map((item) => ({
      item_id: String(item.id),
      item_name: item.name || "",
      price: item.price || 0,
      quantity: item.qty || 1,
    })),
  });
}
